const DataSourceNotice = () => (
  <div className="text-center mt-5 mb-3 px-3">
    این داده‌ها بر اساس اطلاعات داخلی میزفا تولز هستند و ممکن است با سایر منابع
    متفاوت باشند؛ این اختلاف منابع طبیعی است.
  </div>
);

export default DataSourceNotice;
